module.exports = {
    home: '首頁',
    products: '產品介紹',
    suggest: '產品優勢',
    process: '開通流程',
    sign_in: '登錄',
    sign_up: '注冊',
}
